export default __webpack_public_path__ + "static/media/event2.e7897b12.jpg";